module.exports = __webpack_public_path__ + "img/saleout.28609490.png";